// Migrated from styles/root-variables.less: the :root CSS custom properties
// consumed by grid/gap styles (var(--gutter), var(--teaser-gap),
// var(--container-padding), var(--flex-grid-side-padding)). Breakpoint
// transitions mirror the LESS file exactly (768/1240/1536/1920px); the LESS
// file interleaves declarations and media blocks — merged here per media
// query (same computed CSS).
export const rootVariablesStyles = () => ({
  ":root": {
    // This is the gutter in grid/column layout
    "--gutter": "16px",
    "--teaser-gap": "8px",
    "--container-padding": "16px",
    "--flex-grid-side-padding": "calc(var(--gutter) / 2)",
    "@media (min-width: 768px)": {
      "--gutter": "24px",
      "--teaser-gap": "16px",
      "--container-padding": "24px",
    },
    "@media (min-width: 1240px)": {
      "--teaser-gap": "24px",
      "--container-padding": "16px",
    },
    "@media (min-width: 1536px)": {
      "--container-padding": "24px",
    },
    "@media (min-width: 1920px)": {
      "--gutter": "32px",
      "--container-padding": "64px",
    },
  },
});
